"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var function_enhancers_1 = require("@shopify/function-enhancers");

function memoize(resolver) {
  return function (_target, propertyKey, descriptor) {
    var method = descriptor.value;

    if (!method || !(method instanceof Function)) {
      return descriptor;
    }

    return {
      get: function get() {
        var newDescriptor = {
          configurable: true,
          value: function_enhancers_1.memoize(method, resolver)
        };
        Object.defineProperty(this, propertyKey, newDescriptor);
        return newDescriptor.value;
      }
    };
  };
}

exports.default = memoize;